import { ConfigProvider, Segmented } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { SegmentedOptions } from "antd/es/segmented";

type Props<T> = {
  size?: SizeType;
  options: SegmentedOptions<T>;
  vertical?: boolean;
  onChange?: (value: T) => void;
  disabled?: boolean;
  value: T;
};

export const SwitchOptions = <T = unknown,>({
  size = "large",
  options,
  vertical,
  onChange,
  disabled,
  value,
}: Props<T>) => {
  return (
    <ConfigProvider
      theme={{
        token: { borderRadius: 14 },
      }}
    >
      <Segmented
        vertical={vertical}
        shape={vertical ? "default" : "round"}
        block
        size={size}
        options={options}
        onChange={onChange}
        disabled={disabled}
        value={value}
      />
    </ConfigProvider>
  );
};
